// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ff29e54f","585":"fe72056a"}[chunkId] + ".chunk.js";
};